import React, {useEffect, useRef} from "react";
import Image from "../Global/Image";

import styles from "./TitleBloc.module.scss";
import gsap from "gsap";


export default function TitleBloc({image, number, children}) {
    const article = useRef(null);

    useEffect(() => {
        const image = article.current.getElementsByClassName(styles.Image)[0];
        const prevSibling = article.current.previousElementSibling;

        window.addEventListener('scroll', () => {
            const articleRef = article.current.getBoundingClientRect();

            if (articleRef.top <= window.innerHeight * .6) {
                gsap.set(image, {
                    width: '100%',
                    borderRadius: 0,
                    onComplete: () => image.classList.add('animated')
                })

            } else {
                image.classList.remove('animated');

                gsap.set(image, {
                    clearProps: "width,border-radius",
                })
            }

            const siblingRect = prevSibling.getBoundingClientRect();

            if (articleRef.top <= window.innerHeight * .8 && !article.current.classList.contains('stuck')) {
                article.current.classList.add('stuck');

                gsap.set(prevSibling, {
                    position: 'sticky',
                    top: siblingRect.top
                })
            }

            if (articleRef.top > window.innerHeight) {
                article.current.classList.remove('stuck');
            }
        });
    }, []);


    return (
        <article className={styles.Main} ref={article}>
            <Image {...image} classname={styles.Image}>
                <span className={styles.Number}>
                    {number}
                </span>
                {children}
            </Image>
        </article>
    )
}
